import { ReactElement } from 'react'

import { MoonStars, Sun } from '@phosphor-icons/react/dist/ssr'

import { Switch } from '@shared/components/Switch'
import { useTheme } from '@shared/components/Theme/hooks/useTheme'

export const SidebarDesktopDarkMode = (): ReactElement => {
  const { theme, toggleTheme } = useTheme()

  return (
    <section className="mt-6 flex items-center gap-1 self-center">
      <Sun size={16} className="text-text-primary" />
      <Switch checked={theme === 'dark'} onCheckedChange={toggleTheme} />
      <MoonStars size={16} className="text-text-primary" />
    </section>
  )
}
